import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TOKENS, WA_LINK } from '../tokens';

export default function StickyDock() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const obs = new IntersectionObserver(
      ([e]) => setVisible(!e.isIntersecting),
      { threshold: 0.08 }
    );
    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  return (
    <>
      <style>{`
        @media (max-width: 480px) {
          .sticky-dock-info { display: none !important; }
          .sticky-dock-sep  { display: none !important; }
        }
      `}</style>

      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ y: 20, opacity: 0, scale: 0.96 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 20, opacity: 0, scale: 0.96 }}
            transition={{ type: 'spring', stiffness: 340, damping: 30 }}
            style={{
              /* ── Bottom-right corner, not centred ── */
              position: 'fixed',
              bottom: 32,
              right: 32,
              left: 'auto',
              zIndex: 900,
              display: 'flex',
              alignItems: 'center',
              gap: 14,
             background: 'rgba(5,10,26,0.92)',
              backdropFilter: 'saturate(180%) blur(20px)',
              WebkitBackdropFilter: 'saturate(180%) blur(20px)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 980,
              padding: '10px 10px 10px 20px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.04)',
              whiteSpace: 'nowrap',
              maxWidth: 'calc(100vw - 64px)',
            }}
          >
            {/* Property info */}
            <div className="sticky-dock-info">
              <strong style={{
                display: 'block',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '0.98rem',
                fontWeight: 300,
                color: '#fff',
                lineHeight: 1.2,
              }}>
                225 Sq. Yds · Commercial Ground Floor
              </strong>
              <span style={{
                fontSize: '0.6rem',
                color: TOKENS.MUTED,
                letterSpacing: '0.04em',
              }}>
                ₹5.55 Cr · Negotiable
              </span>
            </div>

            {/* Divider */}
            <div
              className="sticky-dock-sep"
              style={{ width: 1, height: 28, background: 'rgba(255,255,255,0.1)', flexShrink: 0 }}
            />

            {/* WhatsApp button only */}
            <a
              href={WA_LINK()}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '11px 20px',
                background: '#25D366',
                color: '#fff',
                borderRadius: 980,
                fontFamily: "'Outfit', sans-serif",
                fontSize: '0.72rem',
                fontWeight: 600,
                letterSpacing: '0.04em',
                textDecoration: 'none',
                transition: 'background 0.2s, transform 0.2s',
                cursor: 'none',
                flexShrink: 0,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = '#1db954';
                e.currentTarget.style.transform = 'scale(1.03)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = '#25D366';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              WhatsApp Us
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
